import { Component, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'kr-warning-save-balance',
  imports: [TranslateModule],
  templateUrl: './warning-save-balance.component.html',
  styleUrl: './warning-save-balance.component.scss',
})
export class WarningSaveBalanceComponent {
  warningKey = input<string>();
  amount = input<number | string>();
  balance = input<number | string>();

  warning(): boolean | null {
    if (!this.amount()) {
      return null;
    }

    if (Number(this.balance()) > Number(this.amount())) {
      return false;
    }

    if (Number(this.balance()) <= Number(this.amount())) {
      return true;
    }

    return null;
  }
}
